import { ref, computed } from 'vue'
import { trackUserActivity } from '@/services/tracking'

interface User {
  id: string;
  username: string;
  full_name: string;
  avatar_url: string;
  updated_at: string;
  isAdmin: boolean;
  isSuperAdmin?: boolean;
  isOwner?: boolean;
  rooftop_id: string;
}

// Initialize from localStorage if available
const savedUser = localStorage.getItem('user_data')
const currentUser = ref<User | null>(savedUser ? JSON.parse(savedUser) : null)

export const useUserStore = () => {
  const setUser = async (user: User) => {
    console.log('Setting user:', user);
    // Preserve existing role flags if they exist
    if (currentUser.value) {
      user = {
        ...user,
        isAdmin: user.isAdmin ?? currentUser.value.isAdmin,
        isSuperAdmin: user.isSuperAdmin ?? currentUser.value.isSuperAdmin,
        isOwner: user.isOwner ?? currentUser.value.isOwner
      }
    }
    currentUser.value = user
    // Persist to localStorage
    localStorage.setItem('user_data', JSON.stringify(user))
    await trackUserActivity('login', user.id, getRooftopId.value);
  }

  const isAdmin = computed(() => currentUser.value?.isAdmin || false)
  const isSuperAdmin = computed(() => currentUser.value?.isSuperAdmin || false)
  const isOwner = computed(() => currentUser.value?.isOwner || false)

  const getRooftopId = computed(() => {
    const rooftopId = currentUser.value?.rooftop_id || ''
    console.log('Getting rooftop ID:', rooftopId);
    return rooftopId
  })

  const clearUser = () => {
    console.log('Clearing user data...');
    currentUser.value = null;
    // Clear any cached data
    localStorage.removeItem('user_data');
    localStorage.removeItem('lastAppState');
    localStorage.removeItem('lastRoute');
  }

  return {
    user: currentUser,
    setUser,
    clearUser,
    isAdmin,
    isSuperAdmin,
    isOwner,
    getRooftopId
  }
} 